import React from "react";
import { compose } from "redux";

import withTranslations from "../../../../../../hocs/withTranslations";
import AliorBank from "../../../components/LandingTypography/assets/alior.png";
import CardOutline from "../../../components/LandingTypography/assets/card-outline.svg";
import Discount from "../../../components/LandingTypography/assets/discount.svg";
import Refund from "../../../components/LandingTypography/assets/refund.svg";
import Saxo from "../../../components/LandingTypography/assets/saxo.png";
import Stripe from "../../../components/LandingTypography/assets/stripe_transparent.png";
import Xtb from "../../../components/LandingTypography/assets/xtb_black.png";
import Visa from "../../../components/LandingTypography/assets/visa.png";
import Mastercard from "../../../components/LandingTypography/assets/mastercard.png";
import useIsDesktop from "../../../hooks/useIsDesktop";

const PlanTable2 = ({ translate }) => {
  const isDesktop = useIsDesktop();

  return isDesktop ? (
    <div className={"plan-table-2"}>
      <table>
        <tbody>
          <tr>
            <td>
              <h2 className={"text-2xl text-black font-semibold text-center"}>
                {translate("plans_additional_heading")}
              </h2>
            </td>
            <td>
              <div className={"flex gap-6 align-center justify-center"}>
                <img
                  alt={translate("plans_additional_refund")}
                  src={Refund}
                  width={48}
                  height={48}
                />
                <div className={"text-left flex flex-col gap-1"}>
                  <h3 className={"text-base text-black font-medium"}>
                    <span className={"font-semibold"}>
                      {translate("plans_additional_satisfaction_heading-1")}
                    </span>
                    <br />
                    {translate("plans_additional_satisfaction_heading-2")}
                  </h3>
                  <p className={"m-0 text-black opacity-60 text-xs.1"}>
                    {translate("plans_additional_satisfaction_subtitle")}
                  </p>
                </div>
              </div>
            </td>
            <td>
              <div className={"flex gap-6 align-center justify-center"}>
                <img
                  src={Discount}
                  alt={translate("plans_additional_partners-discount_discount")}
                  width={48}
                  height={48}
                />
                <div className={"flex gap-3 flex-col"}>
                  <h3 className={"text-base text-black font-medium"}>
                    {translate("plans_additional_partners-discount_heading")}
                  </h3>
                  <div className={"flex gap-4 align-center justify-center"}>
                    <img src={Saxo} alt={"Saxo be invested"} width={46} />
                    <img src={Xtb} alt={"Xtb"} width={53} />
                    <img src={AliorBank} alt={"Alior Bank"} width={43} />
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className={"flex gap-6 align-center justify-center"}>
                <span className={"text-3xl.2 font-extrabold text-black"}>
                  {translate("plans_additional_users_subtitle")}
                </span>
                <h3 className={"text-base text-black font-medium"}>
                  {translate("plans_additional_users_heading")}
                </h3>
              </div>
            </td>
            <td>
              <div className={"flex gap-6 align-center justify-center"}>
                <img src={CardOutline} alt={"Karta"} width={48} height={48} />
                <div className={"flex flex-col gap-3"}>
                  <h3 className={"text-base text-black font-medium"}>
                    {translate("plans_additional_payment-methods_heading")}
                  </h3>
                  <div className={"flex gap-4 align-center justify-center"}>
                    <img src={Stripe} alt={"Stripe"} height={20} />
                    <img src={Visa} alt={"Visa"} height={20} />
                    <img src={Mastercard} alt={"Mastercard"} height={20} />
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div className={"grid justify-center align-center gap-3"}>
                <div className={"flex gap-6 align-center"}>
                  <span className={"text-3xl.2 font-extrabold text-black"}>
                    {translate("plans_additional_markets_subtitle")}
                  </span>
                  <h3 className={"text-base text-black font-medium"}>
                    {translate("plans_additional_markets_heading")}
                  </h3>
                </div>
                <div className={"flex gap-2 flex-col align-center"}>
                  <div className={"flex gap-2"}>
                    <div
                      className={
                        "text-xs.1 opacity-60 text-black font-semibold"
                      }
                    >
                      {translate("plans_additional_markets_text-1")}
                    </div>
                    <div
                      className={
                        "border-r-black border-r-1 border-r-solid h-3 opacity-30"
                      }
                    />
                    <div
                      className={
                        "text-xs.1 opacity-60 text-black font-semibold"
                      }
                    >
                      {translate("plans_additional_markets_text-2")}
                    </div>
                    <div
                      className={
                        "border-r-black border-r-1 border-r-solid h-3 opacity-30"
                      }
                    />
                    <div
                      className={
                        "text-xs.1 opacity-60 text-black font-semibold"
                      }
                    >
                      {translate("plans_additional_markets_text-3")}
                    </div>
                  </div>
                  <div className={"flex gap-2"}>
                    <div
                      className={
                        "text-xs.1 opacity-60 text-black font-semibold"
                      }
                    >
                      {translate("plans_additional_markets_text-4")}
                    </div>
                    <div
                      className={
                        "border-r-black border-r-1 border-r-solid h-3 opacity-30"
                      }
                    />
                    <div
                      className={
                        "text-xs.1 opacity-60 text-black font-semibold"
                      }
                    >
                      {translate("plans_additional_markets_text-5")}
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  ) : (
    <div className={"plan-table-2"}>
      <table>
        <tbody>
          <tr>
            <td>
              <h2
                className={
                  "text-left text-xl text-black font-semibold text-center"
                }
              >
                {translate("plans_additional_heading")}
              </h2>
            </td>
            <td>
              <div
                className={"flex flex-col gap-1 align-center justify-center"}
              >
                <img
                  alt={translate("plans_additional_refund")}
                  src={Refund}
                  width={32}
                  height={32}
                />
                <div className={"flex flex-col gap-1.5"}>
                  <h3
                    className={"text-xs.5 text-black font-medium text-center"}
                  >
                    <span className={"font-semibold"}>
                      {translate("plans_additional_satisfaction_heading-1")}
                    </span>
                    <br />
                    {translate("plans_additional_satisfaction_heading-2")}
                  </h3>
                  <p className={"m-0 text-black opacity-60 text-xs.1"}>
                    {translate("plans_additional_satisfaction_subtitle")}
                  </p>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                className={"flex flex-col gap-1 align-center justify-center"}
              >
                <img
                  src={Discount}
                  alt={translate("plans_additional_partners-discount_discount")}
                  width={32}
                  height={32}
                />
                <div className={"flex gap-1.5 flex-col align-center"}>
                  <h3
                    className={"text-center text-xs.5 text-black font-medium"}
                  >
                    {translate("plans_additional_partners-discount_heading")}
                  </h3>
                  <div className={"flex gap-2 align-center justify-center"}>
                    <img src={Saxo} alt={"Saxo be invested"} width={32} />
                    <img src={Xtb} alt={"Xtb"} width={37} />
                    <img src={AliorBank} alt={"Alior Bank"} width={31} />
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div
                className={"flex gap-1.5 flex-col align-center justify-center"}
              >
                <img src={CardOutline} alt={"Karta"} width={32} height={32} />
                <div className={"flex flex-col gap-1 align-center text-center"}>
                  <h3 className={"text-xs.5 text-black font-medium"}>
                    {translate("plans_additional_payment-methods_heading")}
                  </h3>
                  <div className={"flex gap-2 align-center justify-center"}>
                    <img src={Stripe} alt={"Stripe"} height={15} />
                    <img src={Visa} alt={"Visa"} height={15} />
                    <img src={Mastercard} alt={"Mastercard"} height={15} />
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                className={
                  "flex flex-col gap-1 align-center justify-center text-center"
                }
              >
                <span className={"text-2xl font-extrabold text-black"}>
                  {translate("plans_additional_users_subtitle")}
                </span>
                <h3 className={"text-xs.5 text-black font-medium"}>
                  {translate("plans_additional_users_heading")}
                </h3>
              </div>
            </td>
            <td>
              <div className={"flex-col gap-1 align-center flex text-center"}>
                <span className={"text-2xl font-extrabold text-black"}>
                  {translate("plans_additional_markets_subtitle")}
                </span>
                <h3 className={"text-xs.5 text-black font-medium"}>
                  {translate("plans_additional_markets_heading")}
                </h3>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default compose(withTranslations)(PlanTable2);
